export default "__VITE_PUBLIC_ASSET__1c230666__"